export default __webpack_public_path__ + "static/Eta star-3c793adc6b55a3147b4c6b18b3322ec6.jpg";